import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Media, Product } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Menu } from 'react-native-paper';
import { ModalButton } from '../../shared/components/modalButton';
import { EditFileForm } from '../../files/components/editFileForm';
import { DeleteProductFileModal } from './deleteProductFileModal';

export const ProductFileItemMenu = ({
  product,
  media,
  invalidateQuery,
}: {
  product: Product;
  media: Media;
  invalidateQuery: () => void;
}) => {
  const { t } = useTranslation();

  const [menuVisible, setMenuVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const openMenu = () => {
    setMenuVisible(true);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  const onUpdateProduct = (id: string, title?: string) => {
    closeMenu();
  };

  return (
    <View>
      <Menu
        statusBarHeight={0}
        visible={menuVisible}
        onDismiss={closeMenu}
        contentStyle={styles.menu}
        anchor={
          <TouchableOpacity onPress={openMenu}>
            <MaterialCommunityIcons
              name="dots-horizontal"
              color={Colors.black}
              size={24}
            />
          </TouchableOpacity>
        }
      >
        <ModalButton
          label=""
          customButton={
            <Menu.Item
              trailingIcon={'pencil-outline'}
              titleStyle={styles.edit}
              title={t('product.detail.edit')}
            />
          }
          modalComponent={({ onComplete }) => {
            return (
              <EditFileForm
                onComplete={() => {
                  onComplete();
                  closeMenu();
                  invalidateQuery();
                }}
                fileId={media.id}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
        <Menu.Item
          trailingIcon={'trash-can-outline'}
          titleStyle={styles.delete}
          onPress={() => {
            setIsDeleteModalVisible(true);
            closeMenu();
          }}
          title={t('product.detail.delete')}
          theme={{ colors: { onSurfaceVariant: Colors.red } }}
        />
      </Menu>
      <DeleteProductFileModal
        visible={isDeleteModalVisible}
        hide={() => setIsDeleteModalVisible(false)}
        media={media}
        product={product}
        onDelete={closeMenu}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  menu: {
    backgroundColor: Colors.white,
    top: 30,
    left: 0,
  },
  edit: {
    fontSize: 17,
  },
  delete: {
    color: Colors.red,
    fontSize: 17,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
  },
});
